'use strict';

angular.module('kerp-forms.forms').service(
  'wolverhamptonCareAssessmentCalculator',

  [
    '$window',
    'calculationResultService',

    function (
      $window,
      calculationResultService
    ) {

      const { getConstants, calculator } = $window.kerpCfa.wolverhampton;

      function saveCalcResults(careType, calcResults, model) {
        calculationResultService.saveCalcResults(careType, calcResults, model);
      }

      this.recalculate = function (dirtyModel, cleanModel) {

        var recalculateCareTypes = Object.keys(getConstants().careTypes);
        var self = this;

        recalculateCareTypes.forEach(function (careType) {
          var calcResults = self.calculate(cleanModel, null, careType);

          saveCalcResults(careType, calcResults, dirtyModel);
          saveCalcResults(careType, calcResults, cleanModel);
        });
      };

      this.calculate = function (fields, isShortForm, careType) {
        return calculator(fields, isShortForm, careType);
      };
    }
  ]
);
